import React, { useState, useEffect, useMemo, useLayoutEffect } from "react";

import FilterForm from "app/Components/FilterForm/FilterForm";
import { useArea } from "app/_helpers/hooks";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import { incidentFilterFields } from "../CONSTANTS";
import { UserService } from "app/_services/UserService/UserService";
import { getAuthUser, LOGGED_IN_USER_SITE_ID } from "../../IncidentManagement/Helper";
import { userDropdownLabel } from "app/_helpers/helper";
import moment from "moment";

export default function VFLFilters({ form, onChange, onReset, setForm }) {
  const [state, setState] = useState({
    departments: [],
    subAreas: [],
    initialActivity: [],
    activity: [],
    subActivities: [],
    sites: [],
    roSites: [],
  });

  const [area, areaOption] = useArea();
  const [VFLExecutives, setVFLExecutives] = useState([]);
  const [soList, setSoList] = useState([]);

  // const [activity, setActivity] = useState([]);

  useEffect(() => {
    // getDepartment("filter[status]=1").then((response) => {
    //   if (!response?.data) return;
    //   setState((prev) => ({ ...prev, departments: response.data.departments.map((row) => ({ label: row.name, value: row.id })) }));
    // });
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;
      const userSiteId = LOGGED_IN_USER_SITE_ID();
      const auth_user = getAuthUser();

      setVFLExecutives(
        response.data
          .filter(
            (user) =>
              (user?.accessPermissions || []).filter(
                (d) => d.permission === "vflOfficer" && d.permissionValue === "1"
              ).length &&
              (+auth_user?.role?.roleLable === 1 ||
                +user?.employee?.ehsSite?.id === userSiteId)
          )
          .map((user) => ({
            label: userDropdownLabel(user),
            id: user.id,
            value: user.id,
          }))
      );

      setSoList(
        response.data
          .filter(
            (user) =>
              (user?.accessPermissions || []).filter(
                (d) => d.permission === "safetyOfficer" && d.permissionValue === "1"
              ).length &&
              (+auth_user?.role?.roleLable === 1 ||
                +user?.employee?.ehsSite?.id === userSiteId)
          )
          .map((user) => ({
            label: userDropdownLabel(user),
            id: user.id,
            value: user.id,
          }))
      );
    });

    getAllActivity().then((response) => {
      if (!response?.data) return;
      setState((prev) => ({
        ...prev,
        initialActivity: response?.data,
        activity: response.data.map((row) => ({ label: row.name, value: row.id })),
      }));
    });

    getAllSites("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setState((prev) => ({
        ...prev,
        //initialActivity: response?.data,
        sites: response.data.map((row) => ({ label: row.name, value: row.id })),
        roSites: response.data
          .filter((d) => d.siteType !== 2)
          .map((row) => ({ label: row.name, value: row.id })),
      }));
    });
  }, []);

  const fields = useMemo(
    () =>
      incidentFilterFields.map((f) => {
        const field = { ...f };

        switch (field.name) {
          // case "departmentId":
          //   field.options = state.departments;
          //   break;
          case "areaId":
            field.options = areaOption;
            break;
          case "subAreaId":
            field.options = state.subAreas;
            break;
          case "vflExecutiveId":
            field.options = VFLExecutives;
            break;
          case "activityId":
            field.options = state.activity;
            break;
          case "subActivityId":
            field.options = state.subActivities;
            break;
          case "mineId":
            field.options = state.sites;
            break;
          case "roId":
            field.options = state.roSites;
            break;
          case "vflScheduledBy":
            field.options = soList;
            break;

          default:
            break;
        }

        return field;
      }),
    [
      areaOption,
      state.subAreas,
      state.activity,
      state.subActivities,
      state.sites,
      state.roSites,
      VFLExecutives,
      soList,
    ]
  );

  useLayoutEffect(() => {
    setForm((prev) => ({ ...prev, subAreaId: "" }));
  }, [form.areaId, setForm]);

  useLayoutEffect(() => {
    setForm((prev) => ({ ...prev, subActivityId: "" }));
  }, [form.activityId, setForm]);

  useEffect(() => {
    if (!form.areaId) return setState((prev) => ({ ...prev, subAreas: [] }));

    setState((prev) => ({
      ...prev,
      subAreas:
        area
          .find((d) => d.id === form.areaId)
          ?.subAreaOfOperation.map((d) => ({ name: d.name, value: d.id })) || [],
    }));
  }, [area, form.areaId]);

  useEffect(() => {
    if (!form.activityId) return setState((prev) => ({ ...prev, subActivities: [] }));

    setState((prev) => ({
      ...prev,
      subActivities:
        state.initialActivity
          .find((d) => d.id === form.activityId)
          ?.subActivity.map((d) => ({ name: d.name, value: d.id })) || [],
    }));
  }, [form.activityId, state.initialActivity]);

  console.log("state", state);

  const handleDateRange = (dates) => {
    console.log("dates", dates);
    onChange({
      target: {
        name: "startDate",
        value: dates.startDate
          ? moment(new Date(dates.startDate)).format("YYYY-MM-DD")
          : null,
      },
    });
    onChange({
      target: {
        name: "endDate",
        value: dates.endDate
          ? moment(new Date(dates.endDate)).format("YYYY-MM-DD")
          : null,
      },
    });
  };
  return (
    <div className="pb-4">
      <FilterForm
        fields={fields}
        form={form}
        onChange={onChange}
        onReset={onReset}
        handleDateRange={handleDateRange}
        startDate={form?.startDate || null}
        endDate={form?.endDate || null}
      />
    </div>
  );
}
